import Box from '@mui/material/Box';
import { createFileRoute } from '@tanstack/react-router';
import FindBatchCode from '../features/find-product-batch/FindBatchCode';

const FindBatchCodeComponent = () => {
  return (
    <Box>
      <FindBatchCode />
    </Box>
  );
};

export const Route = createFileRoute('/find-batch-code')({
  component: FindBatchCodeComponent,
});
